import { useCallback, useState } from 'react';
import { IUseModalMostUsedCommand } from '../types';

const useModalMostUsedCommand = ({
  setPrompt,
  onClose,
}: IUseModalMostUsedCommand) => {
  const options = [
    {
      id: 0,
      title: 'IR PARA MEDIDAS',
    },
    {
      id: 1,
      title: 'IR PARA DESEMPENHO',
    },
    {
      id: 2,
      title: 'SUGESTÃO DE COMPRAS DE INSUMO?',
    },
    {
      id: 3,
      title: 'IR PARA DESPESCAS',
    },
    {
      id: 4,
      title: 'IR PARA INÍCIO',
    },
    {
      id: 5,
      title: 'QUAL O MEU MAIOR VIVEIRO?',
    },
    {
      id: 6,
      title: 'COMO ESTÁ O CONSUMO DE INSUMOS?',
    },
  ];

  const handelSetPrompt = useCallback(
    (prompt: string) => {
      setPrompt(prompt);
      onClose();
    },
    [setPrompt]
  );

  return { options, handelSetPrompt };
};

export default useModalMostUsedCommand;
